import React from 'react';
import { ImageBackground, StyleSheet, useWindowDimensions, View, } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { Text } from '@rneui/themed';
import { Image as SkeletonImage } from '../../skeleton';
import { useTheme } from '../../..';
import { Description } from '../../shared';
import { useReactiveThemeProperty } from '../../../hooks/utils';
import { AppearsIn } from '../../content/AppearsIn';
export const CollectionHero = ({ uri, isLoading = false, collection, children, containerStyle, showTitle = true, showDescription = true, showAppearsIn = true, }) => {
    const { width } = useWindowDimensions();
    const horizontalGutter = useReactiveThemeProperty('horizontalGutter');
    const { colors: { backgroundPrimary } } = useTheme();
    if (isLoading) {
        return (React.createElement(SkeletonImage, { width: '100%', height: width / 3 }));
    }
    return (React.createElement(ImageBackground, { source: { uri }, style: styles.background, imageStyle: styles.backgroundImage },
        React.createElement(LinearGradient, { colors: [
                `${backgroundPrimary}00`,
                `${backgroundPrimary}C0`,
                `${backgroundPrimary}`,
            ], style: styles.gradient },
            React.createElement(View, { style: [
                    styles.contentContainer,
                    { paddingHorizontal: horizontalGutter },
                    containerStyle,
                ] },
                showTitle && React.createElement(Text, { h2: true, bold: true, numberOfLines: 2 }, collection?.name),
                showDescription && React.createElement(Description, { text: collection?.description, maxHeight: 100 }),
                showAppearsIn && React.createElement(AppearsIn, { item: collection }),
                children))));
};
const styles = StyleSheet.create({
    contentContainer: {
        alignItems: 'flex-start',
        paddingTop: 50,
        paddingBottom: 50,
    },
    background: {
        alignItems: 'flex-start',
    },
    backgroundImage: {
        opacity: 0.25,
    },
    gradient: {
        width: '100%',
    },
});
//# sourceMappingURL=CollectionHero.js.map